module.exports = "/_next/static/images/b0c773c3a815910607b9a35fab429c36-hero-mobile.png.webp";